import api from '@plugins/axios'

async function get(url, data, type, ignoreErro = false) {
  const formData = new FormData()
  if (data) {
    Object.entries(data).forEach((item) => {
      formData.append(item[0], item[1])
    })
  }

  if (!api[type]) {
    console.info('Tipo de requisição invalida, utilizando get')
  }

  console.log('Enviando: ', formData, 'URL: ', url, '\nType: ', type)

  for (var key of formData.entries()) {
    console.log(key[0] + ', ' + key[1])
  }
  const response = await api[type || 'get'](url, formData).catch((error) => {
    if (!ignoreErro) {
      console.log(error)
      console.log('error', typeof error, JSON.stringify(error))
      try {
        if (
          error &&
          error.response &&
          error.response.status &&
          error.response.status === 401 &&
          global.LOGADO
        ) {
          console.error('Redirecionar para login')
        }
      } catch (e) {
        console.warn(e)
      }
    }
    return error.response || error
  })

  console.log('tipo', typeof response.data)
  if (
    typeof response.data === 'string' &&
    response.data.indexOf('<!DOCTYPE html>') !== -1
  ) {
    console.log('Recebendo: ', 'Página html', 'URL: ', url, '\nType: ', type)
  } else {
    console.log('Recebendo: ', response.data, 'URL: ', url, '\nType: ', type)
  }

  return response.data
}

function post(url, data, ignoreErro = false) {
  return get(url, data, 'post', ignoreErro)
}

export default {
  get,
  post,
  ping: () => {
    console.log('pong')
  },
}
